import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './styles/ShoppingWithHeading.scss';
import ArrowRight from 'dibs-icons/exports/legacy/ArrowRight';

function ShoppingWithHeadingComponent({ shoppingWith, onOpenAllShoppers }) {
    const dataTn = `shopping-${shoppingWith.title}`.toLowerCase().replace(/ /g, '-');
    return (
        <div className={`primary-viewport-width ${styles.header}`}>
            <div className={`primary-page-width ${styles.headerWrapper}`}>
                <h1 className={styles.heading} data-tn={dataTn}>
                    <FormattedMessage
                        defaultMessage="Shopping with {name}"
                        id="ShoppingWithHeading.shoppingWith"
                        values={{ name: shoppingWith.title }}
                    />
                </h1>
                <a
                    className={styles.seeMoreLink}
                    onClick={onOpenAllShoppers}
                    data-tn="see-more-shoppers-link"
                >
                    <FormattedMessage
                        defaultMessage="See More Shoppers"
                        id="ShoppingWithHeading.seeMoreShoppers"
                    />
                    <ArrowRight className={styles.seeMoreIcon} />
                </a>
            </div>
        </div>
    );
}

ShoppingWithHeadingComponent.propTypes = {
    shoppingWith: PropTypes.object.isRequired,
    onOpenAllShoppers: PropTypes.func.isRequired,
};

export const ShoppingWithHeading = createFragmentContainer(ShoppingWithHeadingComponent, {
    shoppingWith: graphql`
        fragment ShoppingWithHeading_shoppingWith on ShoppingWith {
            title
        }
    `,
});
